import i18n from '@sparklayer-io/spark-dash-core/i18n';
import type coreEn from '@sparklayer-io/spark-dash-core/i18n/en';

import en from './en';

export const defaultNS = 'pages' as const;

/** This package's namespaces on top of core's, which is what the runtime bundle merge produces. */
export type TranslationType = Omit<typeof coreEn, keyof typeof en> & typeof en;

// Core owns the instance. This package adds the namespaces its screens translate against, and
// claims the default, because it is the one with unprefixed keys (`t('price_list_builder...')`).
for (const [namespace, bundle] of Object.entries(en)) {
  i18n.addResourceBundle('en', namespace, bundle, true, false);
}
i18n.setDefaultNamespace(defaultNS);

export default i18n;
